import {Component} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {DocumentRequirement} from "../../../../../../models/document-requirement";
import {Registration} from "../../../../../../models/registration";
import {Requirement} from "../../../../../../models/requirement";
import {DocumentRequirementControllerService} from "../../../../../../services/requirement-controller/document-requirement-controller.service";
import {RequirementControllerService} from "../../../../../../services/requirement-controller/requirement-controller.service";
import {RequirementService} from "../../../../../../services/requirement-controller/requirement.service";
import {Store} from "../../../../../../services/store.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {
  DeterminantControllerService,
} from "../../../../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "requirement-list",
  templateUrl: "./requirement-list.component.html",
  providers: [],
  styles: [],
})
export class RequirementListComponent extends TranslatedBaseError {

  public serviceId: string;
  public registration: Registration;
  public result: Requirement;
  public requirement: Requirement;
  public requirements: Requirement[] = [];
  public documentRequirement: DocumentRequirement;
  public determinantMapById: { [key: string]: string } = {};
  public documentRequirementList: any[];
  public selectedDocResult: any;
  public topLayer = "list";
  public listToggle: boolean = false;
  public addNew: boolean = false;
  public userFilter: any = {name: ""};
  public subscription: any;

  constructor(private requirementService: RequirementService,
              private requirementControllerService: RequirementControllerService,
              private documentRequirementService: DocumentRequirementControllerService,
              private determinantService: DeterminantControllerService,
              public store: Store,
              public toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.requirementService.change.subscribe((data) => {
      this.serviceId = data.serviceId;
      this.registration = data.registration;
      this.loadServiceRequirements(data.documentRequirementList);
      this.getServiceDeterminantKeyName();
    });
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public loadServiceRequirements(documentRequirementList) {
    this.requirementControllerService.getServiceRequirements().subscribe(
      (data) => {
        this.removeRequirementsOverlappingWithDocumentRequirementsOrDocumentResults(
          documentRequirementList,
          data);
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public removeRequirementsOverlappingWithDocumentRequirementsOrDocumentResults(documentRequirementsOrDocumentResults: any[], requirements: Requirement[]) {
    for (let j = documentRequirementsOrDocumentResults.length - 1; j >= 0; j--) {
      for (let i = requirements.length - 1; i >= 0; i--) {
        if (requirements[i].id === documentRequirementsOrDocumentResults[j].requirement.id) {
          requirements.splice(i, 1);
        }
      }
    }
    this.requirements = requirements;
    this.documentRequirementList = documentRequirementsOrDocumentResults;
  }

  public deleteRequirement(isConfirmed: boolean, item) {
    if (isConfirmed) {
      this.requirementControllerService.deleteRequirement(item.id).subscribe(
        () => {
          this.requirementService.updateData();
          this.responseSuccessful("Requirement is deleted!");
        },
        (error) => this.showErrorMessageWithTitle("Requirement delete error! ", error),
      );
    }
  }

  public deleteDocRequirement(item) {
    this.documentRequirementService.deleteRegistrationRequirement(item.id).subscribe(
      () => {
        this.requirementService.updateData();
        this.responseSuccessful("Requirement is removed from document");
      },
    );
  }

  public addDocRequirement(item: Requirement) {
    const docReq: DocumentRequirement = new DocumentRequirement();
    docReq.determinants = [];
    docReq.alternative = false;
    docReq.requirement = item;
    if (this.registration) {
      docReq.registrationId = this.registration.id;
      docReq.requirementId = item.id;
      this.documentRequirementService.addRegistrationRequirement(this.registration.id, docReq).subscribe(
        () => {
          this.requirementService.updateData();
          this.responseSuccessful("Requirement is added to registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public openEdit(item: any) {
    if (item.requirement) {
      this.documentRequirement = item;
      this.requirement = item.requirement;
      this.addNew = false;
    } else if (item.id && !item.requirement) {
      this.documentRequirement = new DocumentRequirement();
      this.requirement = item;
      this.documentRequirement.determinants = [];
      this.documentRequirement.alternative = false;
      this.documentRequirement.requirement = this.requirement;
      this.addNew = false;
    } else {
      this.documentRequirement = new DocumentRequirement();
      this.requirement = new Requirement();
      this.documentRequirement.determinants = [];
      this.documentRequirement.alternative = false;
      this.documentRequirement.requirement = this.requirement;
      this.addNew = true;
    }
    this.topLayer = "edit";
  }

  public cancelEdit(event: any) {
    if (event.cancel) {
      this.topLayer = "list";
    }
  }

  public closeLayer() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = undefined;
  }

  public resultWindowSubmitted(event: any) {
    if (event.save) {
      this.requirementService.updateData();
    }
    this.topLayer = "list";
  }

  public setListView(b) {
    this.listToggle = b;
  }

}
